module.exports = __webpack_public_path__ + "img/A01.0723a7a0.png";